import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import SellerInfo from "../../store/sellerInfo";
import StoreBranches from "../../store/storeBranches";
import Sellers from "../../store/storeCategories/sellers";
import StoreTab from "../../store/storeTab";
import Wallet from "../../wallet/wallet";
import WalletFlow from "../../walletFlow/walletFlow";
import PurchaseRecordDetail from "../homeTab/purchaseRecords/purchaseRecordDetial";


export default function StoreContainer({ setTabChild }: { setTabChild: (id: number) => void }) {
    const navigate = useNavigate();
    const setState = (state: string) => navigate(`/market/${state === 'store' ? '' : state}`);
    return (
        <div>
            <Routes>
                <Route index element={<StoreTab setState={setState} setTabChild={setTabChild} />} />
                <Route path="sellers" element={<Sellers setState={setState} setTabChild={setTabChild} />} />
                <Route path="sellerInfo" element={<SellerInfo setState={setState} />} />
                <Route path="storeBranches" element={<StoreBranches />} />
                <Route path="wallet" element={<Wallet setTabChild={setTabChild} setState={setState} />} />
                <Route path="purchaseRecords" element={<WalletFlow setState={setState} />} />
                <Route path="purchaseRecordDetail" element={<PurchaseRecordDetail />} />
                <Route path="*" element={<Navigate to="/market" replace />} />
            </Routes>
        </div>
    )
}
